// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const AngleRightOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M10.3 9.7a.99.99 0 010-1.4 1.01 1.01 0 011.41 0l2.97 2.93a1.09 1.09 0 010 1.55l-2.96 2.93a1.01 1.01 0 01-1.42 0 .99.99 0 010-1.4l2.32-2.3L10.3 9.7z","fill-rule":"evenodd","fill":"currentColor"}}]},"name":"angle-right","theme":"outlined"};

const AngleRightOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={AngleRightOutlinedSvg} />;
  AngleRightOutlined.displayName = 'AngleRightOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(AngleRightOutlined);
